import { _fetch as fetchSecure } from '@hobs/utils/fetch';

/**
 * actionCreator constructor
 * @param {string} uri Call to api
 * @param {string} type Redux constant
 * @param {object} params Params to fetchSecure
 */
export const actionCreator = (uri, type, params = {}) => {
  return dispatch => {
    dispatch(request());
    return fetchSecure(uri, params)
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, ...response };
        }

        dispatch(failure(response.toString()));
        return { success: false, ...response };
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: type.REQUEST };
  }
  function success(response) {
    return { type: type.SUCCESS, response };
  }
  function failure(error) {
    return { type: type.FAILURE, error };
  }
};
